import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Close } from '@micromag/core/components';
import Button from '@micromag/element-button';

var styles = {"container":"micromag-element-webview-container","close":"micromag-element-webview-close","iframe":"micromag-element-webview-iframe","top":"micromag-element-webview-top","icon":"micromag-element-webview-icon"};

var propTypes = {
  iframeRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any // eslint-disable-line
  })]),

  url: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  iframeRef: null,
  url: null,
  width: null,
  height: null,
  closeable: false,
  onClose: null,
  className: null
};
function WebView(_ref) {
  var iframeRef = _ref.iframeRef,
    url = _ref.url,
    width = _ref.width,
    height = _ref.height,
    closeable = _ref.closeable,
    onClose = _ref.onClose,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles.closeable, closeable), className, className !== null)]),
    style: {
      width: width,
      height: height
    }
  }, closeable ? /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Close, {
    className: styles.closeIcon
  }))) : null, /*#__PURE__*/React.createElement("iframe", {
    className: styles.iframe,
    ref: iframeRef,
    title: "Popup",
    src: url || 'about:blank'
  }));
}
WebView.propTypes = propTypes;
WebView.defaultProps = defaultProps;

export { WebView as default };
